export default __webpack_public_path__ + "static/media/ui-payment-type-small-visa.1dbad037.svg";